import { render, staticRenderFns } from "./ProposalGrosMarketGrid.vue?vue&type=template&id=12ba8669&scoped=true"
import script from "./ProposalGrosMarketGrid.vue?vue&type=script&lang=js"
export * from "./ProposalGrosMarketGrid.vue?vue&type=script&lang=js"
import style0 from "./ProposalGrosMarketGrid.vue?vue&type=style&index=0&id=12ba8669&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba8669",
  null
  
)

export default component.exports